module.exports = __webpack_public_path__ + "static/media/dispatch.bcf9d5c9.png";